export { default as PartPaymentDetail } from './AddPartPayment/PartPaymentDetail';
export { default as ViewPayments } from './AddPartPayment/ViewPayments';